module.exports = __webpack_public_path__ + "images/application/b-close@2x-a85029a0.png";